/**
 * Module registry for the request-tender wizard (/ajanlatkeres/:activeTab).
 *
 * Only the reorderable middle steps are registered here. Two steps are fixed
 * and rendered outside the module list by ModularRequestTenderPage.vue:
 *   - `profession` — always first (must run before override config is loaded)
 *   - `terms`      — always last  (submit step)
 *
 * Backend never stores these two slugs.
 */

export const REQUEST_TENDER_PAGE_OWN_MODULES = {
  name: () =>
    import(
      "~/components/_refactored/requestTenderPage/request-tender-page-modules/NameStepModule.vue"
    ),
  "job-description": () =>
    import(
      "~/components/_refactored/requestTenderPage/request-tender-page-modules/JobDescriptionStepModule.vue"
    ),
  city: () =>
    import(
      "~/components/_refactored/requestTenderPage/request-tender-page-modules/CityStepModule.vue"
    ),
  email: () =>
    import(
      "~/components/_refactored/requestTenderPage/request-tender-page-modules/EmailStepModule.vue"
    ),
  phone: () =>
    import(
      "~/components/_refactored/requestTenderPage/request-tender-page-modules/PhoneStepModule.vue"
    ),
};

export const REQUEST_TENDER_PAGE_MODULES = REQUEST_TENDER_PAGE_OWN_MODULES;

/**
 * Fixed step component loaders. These are NOT stored as modules in the
 * backend — the renderer always puts ProfessionStepModule at position 0 and
 * TermsStepModule at the last position regardless of conductor configuration.
 */
export const FIXED_STEP_COMPONENTS = {
  profession: () =>
    import(
      "~/components/_refactored/requestTenderPage/request-tender-page-modules/ProfessionStepModule.vue"
    ),
  terms: () =>
    import(
      "~/components/_refactored/requestTenderPage/request-tender-page-modules/TermsStepModule.vue"
    ),
};

/**
 * Default ordering used as a fallback when no active config exists in the API
 * (and as seed data for the global default the backend can pre-populate).
 *
 * Mirrors the legacy hardcoded wizard order minus `profession` (which is
 * always rendered first) and `terms` (always rendered last).
 */
export const DEFAULT_REQUEST_TENDER_PAGE_MODULES = [
  { slug: "name", label: "Name", position: 0, isVisible: true },
  { slug: "job-description", label: "Job description", position: 1, isVisible: true },
  { slug: "city", label: "City", position: 2, isVisible: true },
  { slug: "email", label: "Email", position: 3, isVisible: true },
  { slug: "phone", label: "Phone", position: 4, isVisible: true },
];

export const getBaseSlug = (slug) => slug;
